import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import i18nMessages from './SideMenuTranslations';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { useContext } from 'react';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { growlErrors } from '../../../utils/NotificationUtil';

const EXPORT_RESPONDENTS = gql`
  mutation exportRespondentsMutation($accountId: ID!) {
    exportRespondents(accountId: $accountId)
  }
`;

const RespondentsSideMenuBuilder = (accountId) => {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const growl = useContext(NotificationContext);

  const [exportRespondentsMutation, { loading }] = useMutation(EXPORT_RESPONDENTS);

  const exportRespondents = async () => {
    try {
      const { data } = await exportRespondentsMutation({
        variables: {
          accountId,
        },
      });
      const url = data.exportRespondents;

      window.open(url, '_blank', 'noreferrer');
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  const buildRespondentMenu = () => {
    const respondents = {
      visible: false,
      label: formatMessage(i18nMessages.respondents),
      icon: 'pi pi-user',
      items: [
        {
          label: formatMessage(i18nMessages.listRespondents),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/respondents`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addRespndent),
          icon: 'pi pi-user-plus',
          command: () => {
            const url = `/accounts/${accountId}/respondents/new`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.importRespondents),
          icon: 'pi pi-window-minimize',
          command: () => {
            const url = `/accounts/${accountId}/respondents/imports`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.exportRespondents),
          icon: loading ? 'pi pi-spin pi-spinner' : 'pi pi-window-maximize',
          command: () => {
            exportRespondents();
          },
          disabled: loading,
        },
      ],
    };

    return respondents;
  };

  return {
    buildRespondentMenu,
  };
};

export default RespondentsSideMenuBuilder;
